class ForecastDetailAction {
    static FORECAST_DETAIL_REQUEST = "FORECAST_DETAIL_REQUEST";
    static FORECAST_DETAIL_SUCCESSFUL = "FORECAST_DETAIL_SUCCESSFUL";
    static FORECAST_DETAIL_FAILED = "FORECAST_DETAIL_FAILED";

    static forecastDetailRequest() {
        return {
            type: this.FORECAST_DETAIL_REQUEST
        };
    }
    static forecastDetailSuccessul(data) {
        return {
            type: this.FORECAST_DETAIL_SUCCESSFUL,
            data
        };
    }
    static forecastDetailFailed(error) {
        return {
            type: this.FORECAST_DETAIL_FAILED,
            error
        };
    }
}

export default ForecastDetailAction;
